'use client'

import React, { useTransition } from 'react'
import { CloseSquareBroken, TrashBin2 } from 'solar-icons'
import { revalidateCarts } from '@/lib/actions'
import { useCheckout } from '@/lib/hooks'
import { cn } from '@/lib/utils'

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  LoadingDots,
} from '@/components/ui'

interface DeletePaymentProps extends React.ComponentPropsWithoutRef<'div'> {
  paymentId: string
  toggle?: React.ReactNode
  callback?: () => void
}

export const DeletePayment = ({ paymentId, callback }: DeletePaymentProps) => {
  const { deletePayment } = useCheckout()
  const [isDeleting, startDeleteTransition] = useTransition()

  const handleDelete = () => {
    startDeleteTransition(async () => {
      deletePayment(paymentId)
      callback?.()
    })
  }

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="outline" className="shrink-0" size="sm">
          <TrashBin2 className="size-4 text-red-500" strokeWidth={2} />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Payment?</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this payment?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting} className="w-full">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={isDeleting}
            onClick={handleDelete}
            variant="destructive"
            className="w-full"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
